import { cva } from 'class-variance-authority'

export const headerStyles = cva([
  'flex',
  'flex-col',
  'justify-between',
  'items-center',
  'w-full',
  'py-2',
])

export const iconStyles = cva([
  'cursor-pointer',
  'hover:text-neutral-300',
  'transition-colors',
])

export const navListItemStyles = cva([
  'border-none',
  'hover:bg-moss-50',
  'rounded-2xl',
  'cursor-pointer',
])
